import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, take } from 'rxjs/operators';
import {Feature} from "@shared/models/features.enum";
import {MainState} from "@store/main.store";

@Directive({
  selector: '[showIfFeature]',
})
export class HasFeatureDirective implements OnInit {

  @Input('showIfFeature') feature: Feature;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private store: Store) {}

  ngOnInit(): void {
    this.store
      .select(MainState.hasFeature)
      .pipe(
        take(1),
        map((filterFn) => filterFn(this.feature))
      )
      .subscribe((value) => {
        if (!this.feature || (this.feature && value)) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }

}
